<template>
  <el-collapse v-model="activeName" :style="{'height': height}" :accordion="accordion">
    <el-collapse-item v-for="item in options" :key="item[props.id]" :name="item[props.id]">
      <template slot="title">
        <i class="iconfont iconyuandian margin_0_10"></i>{{item[props.text]}}
      </template>
      <div class="margin_left_36 column_sta">
        <el-button type="text" v-for="items in item[props.children]" :disabled="disabled || (insertType === 'theme' && items.type !== 'Text')" :key="items.id" @click="select(items)" style="border: none;font-size: 12px;">{{items.text}}</el-button>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>

export default({
  name: 'gj-cascader-select',
  props: {
    height: {
      type: String,
      default: '500px'
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    insertType: {
      type: String,
      default: 'content'
    },
    props: {
      type: Object,
      default: () => {
        return {
          id: 'id',
          text: 'text',
          children: 'children',
        }
      }
    },
    // 是否可以多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否可以查询
    filterable: {
      type: Boolean,
      default: false
    },
    // 手风琴效果
    accordion: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      activeName: null
    }
  },
  methods: {
    select(item) {
      this.$emit('change', item)
    }
  }
})
</script>

<style lang="scss" scoped>
/deep/ .el-collapse {
  background: #fff;
  overflow-Y: auto;
  border: 1px solid #cccccc;
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #cccccc;
    &.is-active {
      border-bottom: 1px solid #cccccc;
    }
    .margin_0_10 {
      margin: 0 10px;
    }
  }
  .el-collapse-item__wrap {
    border-bottom: 1px solid #cccccc;
  }
  .margin_left_36 {
    margin-left: 36px;
  }
  .el-button {
    margin-left: 0;
  }
}
.column_sta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
